import React from 'react'

export default function EmptyBoxSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="187"
      height="137"
      viewBox="0 0 187 137"
      fill="none"
      {...props}
    >
      <path
        d="M152.17 59.5571C152.17 72.7848 147.741 85.2143 140.359 95.021C136.27 100.381 131.387 105.056 125.709 108.705C116.623 114.749 105.608 118.17 93.9103 118.17C61.7711 118.284 35.6509 92.0562 35.6509 59.5571C35.6509 27.172 61.6575 0.830566 93.9103 0.830566C105.608 0.830566 116.51 4.25153 125.709 10.2952C131.387 13.9442 136.27 18.6196 140.359 23.9791C147.741 33.8998 152.17 46.2153 152.17 59.5571Z"
        fill="#EAEEF9"
      />
      <path
        d="M49.5417 51.7048H48.8384C48.3109 51.7048 47.9592 51.5407 47.9592 51.2946C47.9592 51.0484 48.3109 50.8843 48.8384 50.8843H49.5417C50.0692 50.8843 50.4209 51.0484 50.4209 51.2946C50.4209 51.5407 50.0692 51.7048 49.5417 51.7048Z"
        fill="#2D5887"
      />
      <path
        d="M49.5417 54.9871H48.8384C48.3109 54.9871 47.9592 54.823 47.9592 54.5768C47.9592 54.3306 48.3109 54.1665 48.8384 54.1665H49.5417C50.0692 54.1665 50.4209 54.3306 50.4209 54.5768C50.4209 54.823 50.0692 54.9871 49.5417 54.9871Z"
        fill="#2D5887"
      />
      <path
        d="M49.5417 58.2693H48.8384C48.3109 58.2693 47.9592 58.1052 47.9592 57.859C47.9592 57.6128 48.3109 57.4487 48.8384 57.4487H49.5417C50.0692 57.4487 50.4209 57.6128 50.4209 57.859C50.4209 58.1052 50.0692 58.2693 49.5417 58.2693Z"
        fill="#2D5887"
      />
      <path
        d="M49.5417 61.5515H48.8384C48.3109 61.5515 47.9592 61.3874 47.9592 61.1412C47.9592 60.8951 48.3109 60.731 48.8384 60.731H49.5417C50.0692 60.731 50.4209 60.8951 50.4209 61.1412C50.4209 61.3874 50.0692 61.5515 49.5417 61.5515Z"
        fill="#2D5887"
      />
      <path
        d="M81.641 51.7048H70.0751C69.6062 51.7048 69.2936 51.5407 69.2936 51.2946C69.2936 51.0484 69.6062 50.8843 70.0751 50.8843H81.641C82.1099 50.8843 82.4225 51.0484 82.4225 51.2946C82.4225 51.5407 82.1099 51.7048 81.641 51.7048Z"
        fill="white"
      />
      <path
        d="M106.284 61.5515H70.0486C69.5956 61.5515 69.2936 61.3874 69.2936 61.1412C69.2936 60.8951 69.5956 60.731 70.0486 60.731H106.284C106.737 60.731 107.039 60.8951 107.039 61.1412C107.039 61.3874 106.737 61.5515 106.284 61.5515Z"
        fill="url(#paint0_linear_12787_8986)"
      />
      <path
        d="M81.6861 54.9871H65.9273C65.4854 54.9871 65.1909 54.8229 65.1909 54.5768C65.1909 54.3306 65.4854 54.1665 65.9273 54.1665H81.6861C82.128 54.1665 82.4225 54.3306 82.4225 54.5768C82.4225 54.8229 82.128 54.9871 81.6861 54.9871Z"
        fill="#2D5887"
      />
      <path
        d="M93.996 58.2693H65.9257C65.4848 58.2693 65.1909 58.1052 65.1909 57.859C65.1909 57.6128 65.4848 57.4487 65.9257 57.4487H93.996C94.4369 57.4487 94.7308 57.6128 94.7308 57.859C94.5839 58.1052 94.2899 58.2693 93.996 58.2693Z"
        fill="#2D5887"
      />
      <path
        d="M106.24 58.2693H95.5301C95.0505 58.2693 94.7308 58.1052 94.7308 57.859C94.7308 57.6128 95.0505 57.4487 95.5301 57.4487H106.24C106.719 57.4487 107.039 57.6128 107.039 57.859C107.039 58.1052 106.719 58.2693 106.24 58.2693Z"
        fill="white"
      />
      <path
        d="M112.827 58.2693H108.636C108.17 58.2693 107.86 58.1052 107.86 57.859C107.86 57.6128 108.17 57.4487 108.636 57.4487H112.827C113.293 57.4487 113.604 57.6128 113.604 57.859C113.604 58.1052 113.293 58.2693 112.827 58.2693Z"
        fill="url(#paint1_linear_12787_8986)"
      />
      <path
        d="M22.522 103.4H160.375"
        stroke="#D6DEE8"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g filter="url(#filter0_d_12787_8986)">
        <path
          d="M119.347 50.8843V103.4H44.8935C41.9565 103.4 39.7537 101.04 39.7537 98.2367V50.8843H119.347Z"
          fill="white"
        />
      </g>
      <path
        d="M148.887 50.8843V98.2367C148.887 101.187 146.439 103.4 143.53 103.4H119.347V50.8843H148.887Z"
        fill="#DAE1ED"
      />
      <g filter="url(#filter1_d_12787_8986)">
        <path
          d="M148.887 50.8843V98.2367C148.887 101.187 146.439 103.4 143.53 103.4H119.347V50.8843H148.887Z"
          fill="#E7EAF4"
        />
      </g>
      <path
        d="M68.4731 50.8842L84.1293 26.2676H164.478L148.379 50.8842H68.4731Z"
        fill="#C5CDDB"
      />
      <g filter="url(#filter2_d_12787_8986)">
        <path
          d="M68.4731 50.8842L84.1293 26.2676H164.478L148.379 50.8842H68.4731Z"
          fill="url(#paint2_linear_12787_8986)"
        />
      </g>
      <path
        opacity="0.3"
        d="M148.887 51.0281V78.7831H127.348C125.348 78.7831 123.963 77.4889 123.655 75.6194L119.347 50.8843L148.887 51.0281Z"
        fill="url(#paint3_linear_12787_8986)"
      />
      <g filter="url(#filter3_d_12787_8986)">
        <path
          d="M148.268 50.8843H119.347L134.033 73.1424C135.082 74.6165 136.73 75.5009 138.378 75.5009H160.856C162.354 75.5009 163.403 73.7321 162.504 72.5528L148.268 50.8843Z"
          fill="url(#paint4_linear_12787_8986)"
        />
      </g>
      <g filter="url(#filter4_d_12787_8986)">
        <path
          d="M119.347 50.8842L103.582 26.2676H22.522L38.8827 50.8842H119.347Z"
          fill="#E7EAF4"
        />
      </g>
      <path
        d="M79.4763 81.2449H48.4438C47.7187 81.2449 47.1387 80.6978 47.1387 80.014C47.1387 79.3302 47.7187 78.7832 48.4438 78.7832H79.4763C80.2014 78.7832 80.7814 79.3302 80.7814 80.014C80.6364 80.6978 80.2014 81.2449 79.4763 81.2449Z"
        fill="#DAE1ED"
      />
      <path
        d="M79.4763 86.9888H48.4438C47.7187 86.9888 47.1387 86.6241 47.1387 86.1682C47.1387 85.7123 47.7187 85.3477 48.4438 85.3477H79.4763C80.2014 85.3477 80.7814 85.7123 80.7814 86.1682C80.6364 86.6241 80.2014 86.9888 79.4763 86.9888Z"
        fill="#DAE1ED"
      />
      <path
        d="M63.0448 93.5532H48.4642C47.7278 93.5532 47.1387 93.1885 47.1387 92.7327C47.1387 92.2768 47.7278 91.9121 48.4642 91.9121H63.0448C63.7812 91.9121 64.3703 92.2768 64.3703 92.7327C64.223 93.1885 63.6339 93.5532 63.0448 93.5532Z"
        fill="#DAE1ED"
      />
      <defs>
        <filter
          id="filter0_d_12787_8986"
          x="17.7537"
          y="39.8843"
          width="123.594"
          height="96.5156"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11" />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12787_8986"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12787_8986"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_12787_8986"
          x="97.3475"
          y="39.8843"
          width="73.54"
          height="96.5156"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11" />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12787_8986"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12787_8986"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_12787_8986"
          x="46.4731"
          y="15.2676"
          width="140.005"
          height="68.6167"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11" />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12787_8986"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12787_8986"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_12787_8986"
          x="97.3475"
          y="39.8843"
          width="87.4894"
          height="68.6167"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11" />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12787_8986"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12787_8986"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_12787_8986"
          x="0.522034"
          y="15.2676"
          width="140.825"
          height="68.6167"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11" />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12787_8986"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12787_8986"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_12787_8986"
          x1="69.4632"
          y1="61.1579"
          x2="107.083"
          y2="61.1579"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF66A9" />
          <stop offset="1" stopColor="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12787_8986"
          x1="107.898"
          y1="57.8339"
          x2="113.603"
          y2="57.8339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83A6FF" />
          <stop offset="1" stopColor="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_12787_8986"
          x1="116.444"
          y1="25.6982"
          x2="116.444"
          y2="51.1496"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_12787_8986"
          x1="134.124"
          y1="79.3558"
          x2="134.124"
          y2="53.9432"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00289017" stopColor="#606673" stopOpacity="0" />
          <stop offset="1" stopColor="#AAB2C5" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_12787_8986"
          x1="141.078"
          y1="50.3149"
          x2="141.078"
          y2="75.7663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
      </defs>
    </svg>
  )
}
